import React, { useState, useEffect, useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link, useNavigate, useLocation, NavLink } from "react-router-dom";
import Footer from "Component/Footer/Footer";
import Header from "Component/Header/Header";
export default function Printoption() {
  return (
    <div className="position-relative">
      <Header />
      <div className="gradientBgprint">
        <div className=" container-fluid ">
          <Container>
            <Row className="mainSection">
              <Col lg="6" className="">
                <div className="printOption">
                  <h1>Print Option Information Page</h1>
                  <p className="printOptiontext">
                    Only with Terpnash - artists and photographers, can now
                    offer a global distribution of physical prints and digital
                    artwork. Using our network of print shops for producing
                    physical prints, international shipping costs and tariffs
                    are virtually eliminated. Terpnash is the first to offer
                    this option in the world!
                  </p>
                  <p className="printTxt">
                    We have agreements with multiple print shops across the
                    globe in specific regions to maximize an artist's ability to
                    sell worldwide. Artists in these regions can work with an
                    authorized print shop to proof their images and offer them
                    for sale on Terpnash, reducing global shipping costs and
                    tariffs. Imagine, an artist in Australia can now sell a
                    print of their artwork to a client in France who will have
                    it shipped to them from the authorized European Union print
                    shop in Germany. It is truly a global marketplace with
                    Terpnash.
                  </p>
                  <p className="printTxt">
                    All of our authorized print shops offer consistency and high
                    quality. They all use Epson printers, Hahnemuhle Photo Rag
                    Ultra Smooth for paper offerings and archivally rated canvas
                    with a protective varnish spray. Both the paper and canvas
                    options have color rated fastness from 75 to over 100 years.
                    The quality is first rate from industry leaders with decades
                    of experience in their field.
                  </p>
                  <p className="printTxt">
                    As an artist or photographer with Terpnash, you now have 3
                    product options. You can offer a Physical Print as a Limited
                    Edition or Open Edition. The third product option is a
                    digital image, also known as an NFT. The options that you
                    offer are up to you. For Physical Prints you can offer up to
                    four different image sizes per image. Additionally, you can
                    select to have your image printed on either paper only,
                    canvas only, or both. With Terpnash, you now have the
                    ability to offer your customers more choices than ever and
                    reach a completely global audience.
                  </p>
                  <p className="printTxt">
                    Artists or Photographers interested in offering print
                    options should contact the authorized print shop in their
                    area to start the proofing process. Here is a current list
                    of approved print shops:
                  </p>
                </div>
              </Col>
              <Col lg="6">
                <img
                  src={"/images/svg/printopton-img.svg"}
                  className="stayimg"
                  alt=""
                />
              </Col>
            </Row>
            <Row className="Section2">
              <Col lg="3">
                <div className="addressBox me-3">
                  <p className="addresshead">Australia </p>
                  <p className="addresstxt">Prolab</p>
                  <p className="addresstxt">2/38 Bishop Street </p>
                  <p className="addresstxt">Kelvin Grove, 4059 </p>
                  <p className="addresstxt">Queensland </p>
                  <p className="addresstxt">
                    <img
                      src={"/images/svg/phoneicon.svg"}
                      className="icon_width"
                      alt=""
                    />
                    : 61 7 3506 1193{" "}
                  </p>
                  <p className="addresstxt">
                    <img
                      src={"/images/svg/emailicon.svg"}
                      className="icon_width"
                      alt=""
                    />
                    : info@prolab.com.au{" "}
                  </p>
                  <p className="addresstxt">
                    <img
                      src={"/images/svg/webicon.svg"}
                      className="icon_width"
                      alt=""
                    />
                    : prolab.com.au{" "}
                  </p>
                  <p className="addresstxt weblink">
                    <a href="https://www.prolab.com.au/contact-us.php" target="_blank">https://www.prolab.com.au/contact-us.php</a>
                  </p>
                </div>
              </Col>
              <Col lg="3">
                <div className="addressBox me-3">
                  <p className="addresshead">Mainland Europe Germany </p>
                  <p className="addresstxt">Ocina Fotograca GmbH </p>
                  <p className="addresstxt">Schleißheimer Straße 128 Rgb</p>
                  <p className="addresstxt">80797 Munchen </p>
                  <p className="addresstxt">
                    <img
                      src={"/images/svg/phoneicon.svg"}
                      className="icon_width"
                      alt=""
                    />
                    : 49 89 452 141 00
                  </p>
                  <p className="addresstxt">
                    <img
                      src={"/images/svg/emailicon.svg"}
                      className="icon_width"
                      alt=""
                    />
                    : info@ocina-fotograca.de
                  </p>
                  <p className="addresstxt">
                    <img
                      src={"/images/svg/webicon.svg"}
                      className="icon_width"
                      alt=""
                    />
                    : www.ocina-fotograca.de
                  </p>
                </div>
              </Col>
              <Col lg="3">
                <div className="addressBox me-3">
                  <p className="addresshead">The United Kingdom </p>
                  <p className="addresstxt">Genesis Imaging Limited</p>
                  <p className="addresstxt">
                    Unit 1, Hurlingham Business Park{" "}
                  </p>
                  <p className="addresstxt">Sulivan Road, Fulham </p>
                  <p className="addresstxt">London SW6 3DU </p>
                  <p className="addresstxt">
                    <img
                      src={"/images/svg/phoneicon.svg"}
                      className="icon_width"
                      alt=""
                    />
                    : 44 (0)20 7384 6200
                  </p>
                  <p className="addresstxt">
                    <img
                      src={"/images/svg/emailicon.svg"}
                      className="icon_width"
                      alt=""
                    />
                    : info@genesisimaging.com.uk{" "}
                  </p>
                  <p className="addresstxt">
                    <img
                      src={"/images/svg/webicon.svg"}
                      className="icon_width"
                      alt=""
                    />
                    : genesisimaging.co.uk{" "}
                  </p>
                </div>
              </Col>
              <Col lg="3">
                <div className="addressBox">
                  <p className="addresshead">The United States </p>
                  <p className="addresstxt">Centric Photo </p>
                  <p className="addresstxt">4001 East Pima Street</p>
                  <p className="addresstxt">Tucson, AZ 85712 </p>
                  <p className="addresstxt">
                    <img
                      src={"/images/svg/phoneicon.svg"}
                      className="icon_width"
                      alt=""
                    />
                    : 1 (520) 325-0065
                  </p>
                  <p className="addresstxt">
                    <img
                      src={"/images/svg/emailicon.svg"}
                      className="icon_width"
                      alt=""
                    />
                    : csr@centricimaging.com
                  </p>
                  <p className="addresstxt">
                    <img
                      src={"/images/svg/webicon.svg"}
                      className="icon_width"
                      alt=""
                    />
                    : centricphoto.com
                  </p>
                </div>
              </Col>
            </Row>
            <div className="Section2 row">
              <div className="printOption">
                <h2>Print File Preparation Guide for Artists</h2>
                <p className="printTxt">
                  When offering your artwork for sale as prints, it's essential
                  to ensure your digital files meet minimum resolution
                  requirements for each print size. This helps guarantee
                  high-quality results, reduces customer dissatisfaction, and
                  minimizes reprints.
                </p>

                <p className="printTxt">
                  Below is a chart showing the uncompressed file sizes (in
                  megabytes) required to meet professional print standards at
                  common framing sizes. These estimates assume an 8-bit RGB
                  color file at either 300 PPI (pixels per inch) for best
                  results, or 150 PPI for acceptable quality.
                </p>

                <p className="printTxt">
                  These sizes are provided for reference only. Artists can use
                  the table to find the closest shape or proportion to their
                  artwork in order to understand the approximate file size
                  needed for printing, even if their final artwork dimensions
                  vary.
                </p>
                <br />
                <h2 className="mb-3">
                  Uncompressed File Size Requirements (TIFF or High-Quality
                  JPEG)
                </h2>

                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">Print Size</th>
                      <th scope="col">PPI</th>
                      <th scope="col">Pixel Dimensions</th>
                      <th scope="col">Uncompressed File Size (MB)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="">8 × 10</th>
                      <td>300</td>
                      <td>2400 × 3000</td>
                      <td>20.6</td>
                    </tr>
                    <tr>
                      <th scope=""></th>
                      <td>150</td>
                      <td>1200 × 1500</td>
                      <td>5.2</td>
                    </tr>
                    <tr>
                      <th scope="">11 × 14</th>
                      <td>300</td>
                      <td>3300 × 4200</td>
                      <td>39.7</td>
                    </tr>
                    <tr>
                      <th scope=""></th>
                      <td>150</td>
                      <td>1650 × 2100</td>
                      <td>9.9</td>
                    </tr>
                    <tr>
                      <th scope="">16 × 20</th>
                      <td>300</td>
                      <td>4800 × 6000</td>
                      <td>82.4</td>
                    </tr>
                    <tr>
                      <th scope=""></th>
                      <td>150</td>
                      <td>2400 × 3000</td>
                      <td>20.6</td>
                    </tr>
                    <tr>
                      <th scope="">20 × 24</th>
                      <td>300</td>
                      <td>6000 × 7200</td>
                      <td>123.8</td>
                    </tr>
                    <tr>
                      <th scope=""></th>
                      <td>150</td>
                      <td>3000 × 3600</td>
                      <td>30.9</td>
                    </tr>
                    <tr>
                      <th scope="">30 × 40</th>
                      <td>300</td>
                      <td>9000 × 12000</td>
                      <td>371.5</td>
                    </tr>
                    <tr>
                      <th scope=""></th>
                      <td>150</td>
                      <td>4500 × 6000</td>
                      <td>92.9</td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <h2>
                  JPEG Compression: Understanding "Closed" vs. "Open" File Sizes
                </h2>
                <p className="printTxt">
                  A JPEG is a compressed file format designed to reduce file
                  size by permanently discarding some image data. This process
                  is called lossy compression. The amount of information
                  discarded depends on how aggressively the file was compressed.
                </p>

                <p className="printTxt">
                  The key point: A JPEG's 'closed' file size (what you see on
                  your computer) may be much smaller than its actual 'open' size
                  used in printing.
                </p>
                <br />
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">Print Size</th>
                      <th scope="col">PPI</th>
                      <th scope="col">Uncompressed</th>
                      <th scope="col">Low Comp.</th>
                      <th scope="col">Med. Comp.</th>
                      <th scope="col">High Comp.</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="">8 × 10</th>
                      <td>300 / 150</td>
                      <td>20.6 / 5.2</td>
                      <td>4-8 / 1-2</td>
                      <td>2-4 / 0.7-1.5</td>
                      <td>0.5-1 / &lt; 0.5</td>
                    </tr>

                    <tr>
                      <th scope="">11 × 14</th>
                      <td>300 / 150</td>
                      <td>39.7 / 9.9</td>
                      <td>8-15 / 2-4</td>
                      <td>4-8 / 1-2</td>
                      <td>1-2 / 0.5-1</td>
                    </tr>

                    <tr>
                      <th scope="">16 × 20</th>
                      <td>300 / 150</td>
                      <td>82.4 / 20.6</td>
                      <td>15-25 / 3-6</td>
                      <td>5-10 / 1.5-3</td>
                      <td>1-3 / 0.5-1</td>
                    </tr>

                    <tr>
                      <th scope="">20 × 24</th>
                      <td>300 / 150</td>
                      <td>123.8 / 30.9</td>
                      <td>25-40 / 5-8</td>
                      <td>8-15 / 2.5-5</td>
                      <td>2-5 / 1-2</td>
                    </tr>
                    <tr>
                      <th scope="">30 × 40</th>
                      <td>300 / 150</td>
                      <td>371.5 / 92.9</td>
                      <td>45-75 / 12-25</td>
                      <td>15-30 / 4-10</td>
                      <td>5-10 / 1-3</td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <h2>Best Practices for Photographing Your Work</h2>

                <p className="printTxt">
                  - Always shoot at the highest quality setting on your camera.
                  If you're saving as JPEG, make sure it's set to Fine.
                </p>
                <p className="printTxt">
                  - Avoid resizing your image smaller or applying extra
                  compression before upload.
                </p>
                <p className="printTxt">
                  - TIFF or high-quality JPEGs are acceptable. Avoid repeated
                  re-saving of JPEGs.
                </p>
                <p className="printTxt">
                  - Use the above chart to determine whether your file is large
                  enough for your chosen print size.
                </p>
                <br />
                <h2>
                  Technical Note: How JPEG Compression Works (Optional Deep
                  Dive)
                </h2>

                <p className="printTxt">
                  Compression is easy to visualize - squeezing something to make
                  it smaller. But lossy compression, the kind used in JPEGs, is
                  harder to explain because it doesn't just squeeze - it
                  permanently discards some image data in the process.
                </p>
                <p className="printTxt">
                  - JPEG files use lossy compression - meaning they shrink the
                  file size by simplifying the image. Fine detail, subtle
                  gradients, and texture may be permanently reduced. The more
                  compression applied, the more detail is lost. A JPEG saved at
                  a high quality setting (e.g., 'Fine' in most cameras) usually
                  looks great and can print beautifully. But if that same file
                  is re-saved multiple times or was heavily compressed to begin
                  with, the loss becomes visible - especially in large prints.
                </p>
                <p className="printTxt">
                  Whenever possible, retain your original file and export a
                  high-quality version just once.
                </p>
                <p className="printTxt">
                  Still not sure if your file is big enough? Ask your print
                  provider for a quick file check before committing to a full
                  print run.
                </p>
              </div>
            </div>
          </Container>
        </div>
      </div>
      <Footer />
    </div>
  );
}
